import { messageConstants } from "../Constants/messageConstant";

const initialState = {
  message: {},
  loanMessagesUnread: 0,
  martMessagesUnread: 0,
  supportMessagesUnread: 0,
  messageDetailed: {},
  messages: [],
  isLoading: false,
  conversations: [],
  usersForChat: {},
  response: {
    state: null,
    message: "",
    action: "",
  },
};

const messageReducer = (state = initialState, action) => {
  switch (action.type) {
    case messageConstants.LOADING:
      return {
        ...state,
        isLoading: action.isLoading,
      };
    case messageConstants.GET_MESSAGE_DETAILED:
      return {
        ...state,
        messageDetailed: action.payload.messageDetailed,
      };
    case messageConstants.GET_CONVERSATIONS:
      return {
        ...state,
        conversations: action.payload.conversations,
      };
    case messageConstants.GET_MESSAGES:
      return {
        ...state,
        messages: action.payload.messages,
      };
    case messageConstants.LOAN_OFFICERS_UNREAD:
      return {
        ...state,
        loanMessagesUnread: action.payload.loanMessagesUnread,
      };
    case messageConstants.MART_OFFICERS_UNREAD:
      return {
        ...state,
        martMessagesUnread: action.payload.martMessagesUnread,
      };
    case messageConstants.CUSTOMER_SERVICE_UNREAD:
      return {
        ...state,
        supportMessagesUnread: action.payload.supportMessagesUnread,
      };
    case messageConstants.GET_USERS_FOR_CHAT:
      return {
        ...state,
        usersForChat: action.payload.usersForChat,
      };
    case messageConstants.RESPONSE:
      return {
        ...state,
        response: {
          state: action.response.state,
          message: action.response.message,
        },
      };

    // ── Real-time: append a single new chat message (no re-fetch) ──
    case messageConstants.APPEND_CHAT_MESSAGE: {
      const existingChat = state.messageDetailed?.chat || [];
      const existingIds = new Set(existingChat.map((m) => m._id));
      if (action.payload._id && existingIds.has(action.payload._id)) {
        return state;
      }
      return {
        ...state,
        messageDetailed: {
          ...state.messageDetailed,
          chat: [...existingChat, action.payload],
        },
      };
    }

    // ── Real-time: update the last message in the messages list ──
    case messageConstants.UPDATE_MESSAGES_LIST_ITEM: {
      const { conversationId, lastMessage, updatedAt } = action.payload;
      const updated = state.messages.map((m) => {
        if (m._id?.toString() === conversationId) {
          return {
            ...m,
            chat: [...(m.chat || []), lastMessage],
            updated_at: updatedAt,
          };
        }
        return m;
      });
      return { ...state, messages: updated };
    }

    default:
      return state;
  }
};

export default messageReducer;
